import Phaser from "phaser"
import { calculateScaleFactor } from "../config/scaling"
import { checkLocalSavedData } from "../helpers/levelManager"
import {
	updateMiniLevel,
	destroyTooltip,
	displayTooltip,
} from "../helpers/levelManager"
import SoundManager from "../managers/sound-manager"
export default class GameUI extends Phaser.Scene {
	constructor() {
		super({ key: "GameUI" })
	}

	init() {
		// Initialize any properties needed
		this.savedUserData = null
		this.savedLevel = 0
		this.savedMiniLevel = 0

		// Game dimensions and scaling
		this.gameW = this.cameras.main.width
		this.gameH = this.cameras.main.height

		// Get scaling information
		const scalingData = calculateScaleFactor(this)
		this.scaleFactor = scalingData.scaleFactor
		this.safeZoneX = scalingData.safeZoneX
		this.safeZoneY = scalingData.safeZoneY
		this.safeZoneWidth = scalingData.safeZoneWidth
		this.safeZoneHeight = scalingData.safeZoneHeight
		this.templateY = scalingData.templateY

		this.soundOn = true

		this.soundManager = new SoundManager(this, {
			musicVolume: 0.4,
			effectsVolume: 0.6,
		})
	}

	loadSavedData() {
		this.savedUserData = checkLocalSavedData()
		this.savedLevel = this.savedUserData?.userLevel || 0
		this.savedMiniLevel = this.savedUserData?.userMiniLevel || 0
		this.currentPlanet = this.savedUserData?.currentPlanet || 0
	}

	create() {
		this.createMuteButton()
	}

	createMuteButton() {
		this.muteButtonn = this.add
			.image(this.gameW - 60 * this.scaleFactor, 40 * this.scaleFactor, "soundOn")
			.setScale(this.scaleFactor * 0.5)
			.setDepth(100)
			.setInteractive()

		let settings = this.soundManager.muteSettings
		console.log("Settings: " + settings)

		if (settings) {
			this.muteButtonn.setTexture("soundOff")
			this.soundOn = false
		} else {
			this.muteButtonn.setTexture("soundOn")
			this.soundOn = true
		}

		this.muteButtonn.on("pointerdown", () => {
			if (this.soundOn) {
				this.soundOn = false
				this.muteButtonn.setTexture("soundOff")
				this.soundManager.mute()
			} else {
				this.soundOn = true
				this.muteButtonn.setTexture("soundOn")
				this.soundManager.unmute()
			}
		})
	}
}
